import { useAuth0 } from '@eigtech/ui-shared-auth'
import { useMemo } from 'react'

export function useGetUserInboxId() {
  const { user } = useAuth0()

  return useMemo(() => user?.sub ?? '', [user])
}
